<template>
  <section>
    <gs-header title="Quản lý phiếu thu">
      <router-link :to="{name: 'create-receipt'}" class="ui mini blue button"><i class="fa fa-plus"></i> Thêm mới</router-link>
    </gs-header>
    <div class="padding-sm-all">
      <gs-table
        :ref="receiptTable"
        :table-name="receiptTable"
        data-source="receipts"
        :data-params="filters"
        :data-sorted="sorted"
        :data-sorts="sorts"
        @remove-filter="removeFilter"
      >
        <section slot="filters">
          <el-row :gutter="10">
            <el-col :span="6">
              <div class="block">
                <el-date-picker
                  size="small"
                  class="width-100"
                  v-model="filterDateRange"
                  type="daterange"
                  range-separator=" / "
                  @input="updateFilters"
                  format="dd-MM-yyyy"
                  start-placeholder="Từ ngày"
                  end-placeholder="Đến ngày">
                </el-date-picker>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="10" class="margin-top">
            <el-col :span="24">
              <a class="cursor-pointer padding-all" @click.prevent="setFilterStatus(status.key, status.value)" v-for="(status, index) in statuses" :class="[{'active-status': status.value === filters[status.key]}, status.class]">{{status.title}}</a>
            </el-col>
          </el-row>
        </section>
        <template slot-scope="datas">
          <el-table
            :data="datas.data"
            border
            style="width: 100%">
          >
            <el-table-column
                label="#"
                width="80"
              >
                <template slot-scope="scope">
                  <small v-if="dataPaginations[receiptTable]">{{(scope.$index + 1) + ((dataPaginations[receiptTable].current_page -1) * dataPaginations[receiptTable].per_page)}}</small>
                </template>
              </el-table-column>

            <el-table-column
              label="Phiếu thu"
              width="150"
            >
              <template slot-scope="scope">
                <p><span class="shipment-code-display click-copy">{{scope.row.id}}</span></p>
                <p>
                  <el-tooltip placement="top" content="Ngày tạo" class="display-inline">
                    <span>{{scope.row.created_at}}</span>
                  </el-tooltip>
                </p>
              </template>
            </el-table-column>

            <el-table-column
              label="Người tạo"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.creator">
                  <p><i class="fa fa-user"></i>&nbsp;{{scope.row.creator.data.name}}</p>
                  <p><i class="fa fa-sign-in"></i>&nbsp;{{scope.row.creator.data.email}}</p>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              label="Người xác nhận"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.confirmer">
                  <p><i class="fa fa-user"></i>&nbsp;{{scope.row.confirmer.data.name}}</p>
                  <p><i class="fa fa-sign-in"></i>&nbsp;{{scope.row.confirmer.data.email}}</p>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              label="Lý do"
            >
              <template slot-scope="scope">
                <small>{{scope.row.description}}</small>
              </template>
            </el-table-column>

            <el-table-column
              label="Tổng tiền"
            >
              <template slot-scope="scope">
                <span class="text-red click-copy">{{scope.row.real_amount | vnd}}</span>
              </template>
            </el-table-column>

            <el-table-column
              width="95"
            >
              <template slot-scope="scope">
                <section class="padding-sm-top padding-sm-bottom">
                  <el-tooltip placement="top" content="Chi tiết" class="display-inline">
                    <router-link class="text-blue padding-all display-inline-block" :to="{name: 'detail-receipt', params: {id: scope.row.id}}"><i class="fa fa-search" aria-hidden="true"></i></router-link>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Sửa" class="display-inline" v-if="!scope.row.confirmer_id">
                    <router-link class="text-orange padding-all display-inline-block" :to="{name: 'edit-receipt', params: {id: scope.row.id}}"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></router-link>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Xóa" class="display-inline" v-if="!scope.row.confirmer_id">
                     <a @click.prevent="deleteReceipt(scope.row)" class="text-red padding-all display-inline-block cursor-pointer"><i class="fa fa-trash"></i></a>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Xác nhận" class="display-inline" v-if="!scope.row.confirmer_id">
                     <a @click.prevent="confirmReceipt(scope.row)" class="text-green padding-all display-inline-block cursor-pointer"><i class="fa fa-check"></i></a>
                  </el-tooltip>
                </section>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </gs-table>
    </div>
  </section>
</template>

<script>
  import ls from 'local-storage'
  import { debounce, keys, forEach } from 'lodash'
  import { formatDate } from 'src/helpers'
  import { mapGetters, mapActions } from 'vuex'
  import { deleteReceipt, confirmReceipt } from 'src/api/receipt'
  export default {
    name: 'Receipt',
    data () {
      return {
        receiptTable: 'receipts',
        filterDateRange: '',
        confirmModal: false,
        filters: {
          sort: 'created_at:-1',
          include: 'creator,confirmer',
          is_confirm: 0,
          start_date: '',
          end_date: ''
        },
        sorted: {
          created_at: -1
        },
        sorts: [
          {key: 'created_at', name: 'Ngày tạo'}
        ],
        statuses: [
          {key: 'is_confirm', value: 0, title: 'Chưa xác nhận', class: 'text-red'},
          {key: 'is_confirm', value: 1, title: 'Đã xác nhận', class: 'text-orange'},
          {key: 'all', value: 1, title: 'Tất cả', class: 'text-blue'}
        ]
      }
    },
    computed: {
      ...mapGetters('receipt', ['receipt'])
    },
    methods: {
      ...mapActions('receipt', ['setReceipt']),
      updateFilters (data) {
        this.filters.start_date = formatDate(data[0])
        this.filters.end_date = formatDate(data[1])
        this.filter()
      },
      setFilterStatus (key, value) {
        this.filters['is_confirm'] = -1
        this.filters['all'] = ''
        this.filters[key] = value

        this.filter()
      },
      filter: debounce(function () {
        let lsFilter = ls.get('filters', {})
        if (!lsFilter) {
          lsFilter = {}
        }
        lsFilter[this.receiptTable] = this.filters
        ls.set('filters', lsFilter)
        if (ls.get('doFilter')) {
          this.reloadGsTable(this.receiptTable)
        }
      }, 300),
      removeFilter () {
        if (this.checkDefaultFilter({
          sort: 'created_at:-1',
          include: 'creator,confirmer',
          is_confirm: 0,
          start_date: '',
          end_date: ''
        }) || this.filters.is_confirm !== 0 || this.filters.is_confirm !== -1) {
          this.reloadGsTable(this.receiptTable)
        }
        this.filterDateRange = ''
        this.filters = {
          sort: 'created_at:-1',
          include: 'creator,confirmer',
          is_confirm: 0,
          start_date: '',
          end_date: ''
        }
      },
      checkDefaultFilter (filters) {
        let diff = false
        let lkeys = keys(filters)
        forEach(lkeys, key => {
          if (filters[key] !== this.filters[key]) {
            this.diff = true
          }
        })
        return diff
      },
      deleteReceipt (receipt) {
        this.setReceipt(receipt)
        this.$confirm(`Bạn chắc chắn muốn xóa phiếu thu ${this.receipt.id}`, 'Xóa phiếu thu', {
          confirmButtonText: 'Xóa',
          cancelButtonText: 'Không',
          type: 'warning'
        }).then(() => {
          this.delReceipt()
        }).catch(() => {

        })
      },
      confirmReceipt (receipt) {
        this.setReceipt(receipt)
        this.$confirm(`Bạn chắc chắn muốn xác nhận phiếu thu ${this.receipt.id}`, 'Xác nhận phiếu thu', {
          confirmButtonText: 'Xác nhận',
          cancelButtonText: 'Không',
          type: 'warning'
        }).then(() => {
          this.confReceipt()
        }).catch(() => {

        })
      },
      delReceipt () {
        deleteReceipt(this.receipt.id).then(response => {
          if (response.code === 200) {
            this.$message({
              type: 'success',
              message: 'Xóa phiếu thu thành công'
            })
            this.reloadGsTable(this.receiptTable)
          } else {
            this.$message({
              type: 'error',
              message: 'Xóa phiếu thu thất bại'
            })
          }
        })
      },
      confReceipt () {
        confirmReceipt(this.receipt.id).then(response => {
          if (response.code === 200) {
            this.$message({
              type: 'success',
              message: 'Xác nhận phiếu thu thành công'
            })
            this.reloadGsTable(this.receiptTable)
          } else {
            this.$message({
              type: 'error',
              message: 'Xác nhận phiếu thu thất bại'
            })
          }
        })
      }
    },
    mounted () {
      this.clickToCopy()
      if (ls.get('filters') && ls.get('filters')[this.receiptTable]) {
        this.filters = ls.get('filters')[this.receiptTable]
        setTimeout(() => {
          ls.set('doFilter', true)
        }, 100)
      }
      this.listenReloadGsTable()
      this.sorted = this.getSorted(this.receiptTable)
    },
    beforeRouteEnter (to, from, next) {
      if (from.fullPath === '/') {
        ls.remove('filters')
        ls.set('doFilter', true)
      } else {
        if (ls.get('filters') && ls.get('filters')['receipts']) {
          ls.set('doFilter', false)
        } else {
          ls.set('doFilter', true)
        }
      }
      next()
    }
  }
</script>

<style lang="css" scoped>
  .active-status{
    font-weight: bold;
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// Receipt.vue?7d54839e